var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58579 20.4142C6.21071 20.0391 6 19.5304 6 19V8C6 7.44772 6.44772 7 7 7H17C17.5523 7 18 7.44771 18 8V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H8C7.46957 21 6.96086 20.7893 6.58579 20.4142Z",
    fill: "#D1FE17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 5C19 4.44772 18.5523 4 18 4H15.9142C15.649 4 15.3946 3.89464 15.2071 3.70711L14.7929 3.29289C14.6054 3.10536 14.351 3 14.0858 3H9.91421C9.649 3 9.39464 3.10536 9.20711 3.29289L8.79289 3.70711C8.60536 3.89464 8.351 4 8.08579 4H6C5.44772 4 5 4.44772 5 5C5 5.55228 5.44772 6 6 6H18C18.5523 6 19 5.55228 19 5Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon_bin.f61af58d83b6463b4cf577cfdd291fa3.svg";
export { ForwardRef as ReactComponent };